export const LOAN_APP_STATUS_TYPES = {
  SETTLE_STATUS_ID: 100,
  SETTLE_CONVERSION_STATUS: 2,
  SETTLEMENT_DATE_ID: 12,
  NOT_PROCEEDED: 19,
  NOT_PROCEEDED_CONVERSION_STATIS: 9,
  NOT_PROCEEDED_STATUS_ID: 101,
};
